import { useCallback } from "react";
import { z } from "zod";
import React from "react";
import { useSetAtom, useAtomValue } from "jotai";
import {
  executeZslAndSaveSetter,
  isExecutingZslAtom,
} from "@zapier/canvas-state";
import { Button } from "@zapier/design-system";

import styles from "../shared/buttonStyles.module.css";
import { BuildItButtonParamsSchema } from "./index";

export type BuildItButtonParams = z.infer<typeof BuildItButtonParamsSchema>;

export function BuildItButton() {
  const executeZslAndSave = useSetAtom(executeZslAndSaveSetter);
  const isExecuting = useAtomValue(isExecutingZslAtom);

  const handleButtonClick = useCallback(async () => {
    // Execute ZSL and transition to build mode
    try {
      await executeZslAndSave({
        prompt: "", // Empty prompt for direct execution
        copilot: null, // No copilot context needed for direct build action
      });
    } catch {
      // If execution fails, send "Fix the error in my canvas." message to the copilot chat
      // This matches the pattern used by the existing Build it button in AiCopilotBanner
      window.postMessage(
        {
          type: "COPILOT_USER_MESSAGE",
          payload: {
            message: "Fix the error in my canvas.",
            source: "build_it_button",
          },
        },
        "*",
      );
    }
  }, [executeZslAndSave]);

  return (
    <div className={styles.container}>
      <Button
        variant="primary"
        size="compact"
        onPress={handleButtonClick}
        isPending={isExecuting}
      >
        Build it
      </Button>
    </div>
  );
}
